import { createSlice, createSelector } from '@reduxjs/toolkit';
import { largeDataAnalyticsAsyncThunks, runProcessSimulation } from '../../Api/largeDataAnalyticsExternalApi';

const largeDataAnalyticsSlice = createSlice({
  name: 'largeDataAnalytics',
  initialState: {
    models: {},
    scenarios: {},
    requests: {},
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    Object.values(largeDataAnalyticsAsyncThunks).forEach((thunk) => {
      builder
        .addCase(thunk.pending, (state, action) => {
          state.loading = true;
        })
        .addCase(thunk.fulfilled, (state, action) => {
          state.loading = false;
          const { name, data, hash } = action.payload;
          console.log('Hash:', hash, 'Data:', data, 'Name:', name)
          if (!state.models[name]) {
            state.models[name] = [];
          }

          state.models[name].push(data);
          state.requests[hash] = data; // Store the hash and its corresponding data
        })
        .addCase(thunk.rejected, (state, action) => {
          state.loading = false;
          state.error = action.payload;
        });
    });

    // Specific handling for runProcessSimulation
    builder
      .addCase(runProcessSimulation.pending, (state) => {
        state.loading = true;
      })
      .addCase(runProcessSimulation.fulfilled, (state, action) => {
        state.loading = false;
        const { process_name, data, hash } = action.payload;

        if (!state.scenarios[process_name]) {
          state.scenarios[process_name] = [];
        }

        state.scenarios[process_name].push(data);
        state.requests[hash] = data; // Store the hash and its corresponding data
      })
      .addCase(runProcessSimulation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default largeDataAnalyticsSlice.reducer;
export const actions = largeDataAnalyticsAsyncThunks;

// Selectors
export const selectLatestLargeDataModel = createSelector(
  (state) => state.largeDataAnalytics.models,
  (state, modelName) => modelName,
  (models, modelName) => {
    if (!models[modelName] || models[modelName].length === 0) {
      return null;
    }
    return models[modelName][models[modelName].length - 1];
  }
);

export const selectAllLargeDataModels = createSelector(
  (state) => state.largeDataAnalytics.models,
  (state, modelName) => modelName,
  (models, modelName) => {
    if (!models[modelName]) {
      return [];
    }
    return models[modelName];
  }
);

export const selectLatestScenario = createSelector(
  (state) => state.largeDataAnalytics.scenarios,
  (state, processName) => processName,
  (scenarios, processName) => {
    if (!scenarios[processName] || scenarios[processName].length === 0) {
      return null;
    }
    return scenarios[processName][scenarios[processName].length - 1];
  }
);

export const selectAllScenarios = createSelector(
  (state) => state.largeDataAnalytics.scenarios,
  (state, processName) => processName,
  (scenarios, processName) => {
    if (!scenarios[processName]) {
      return [];
    }
    return scenarios[processName];
  }
);
